<template>
    <div>
        <el-table
            :data="repair_list"
            height="600"
            tooltip-effect="dark">
            <!-- 维修单号 -->
            <el-table-column
                :label="$t('message.repair.table1')"
                align="center"
                show-overflow-tooltip>
                <template v-slot="{ row }">
                    <el-button
                        type="text"
                        @click="handleGetDetail(row.id)">
                        {{row.service_sn}}
                    </el-button>
                </template>
            </el-table-column>
            <!-- 机器名称 -->
            <el-table-column
                prop="protocol_name"
                :label="$t('message.repair.form3')"
                align="center"
                show-overflow-tooltip>
            </el-table-column>
            <!-- 是否我司购买 -->
            <el-table-column
                :label="$t('message.repair.form6')"
                align="center"
                show-overflow-tooltip>
                <template v-slot="{ row }">
                    <div>{{row.this_website==5? $t("public.radio2"): $t("public.radio1")}}</div>
                </template>
            </el-table-column>
            <!-- 提交时间 -->
            <el-table-column
                :label="$t('message.repair.table2')"
                align="center"
                show-overflow-tooltip>
                <template v-slot="{ row }">
                    <div v-if="row.addtime">{{row.addtime.split(" ")[0]}}</div>
                </template>
            </el-table-column>
            <!-- 维修时间 -->
            <el-table-column
                :label="$t('message.repair.table3')"
                align="center"
                show-overflow-tooltip>
                <template v-slot="{ row }">
                    <div v-if="row.edittime">{{row.edittime.split(" ")[0]}}</div>
                </template>
            </el-table-column>
            <!-- 状态 -->
            <el-table-column
                :label="$t('message.repair.table4')"
                align="center"
                show-overflow-tooltip>
                <template v-slot="{ row }">
                    <div>{{{val: row.status, lang: $t('message.repair')} | repair_status}}</div>
                </template>
            </el-table-column>
        </el-table>
    </div>
</template>

<script>
import { mapState, mapMutations, mapActions } from "vuex";

export default {
    filters: {
        repair_status({val,lang}){
            switch (val) {
                case "0":
                    return lang.filter1;
                    break;
                case "10":
                    return lang.filter2;
                    break;
                case "20":
                    return lang.filter3;
                    break;
                case "30":
                    return lang.filter4;
                    break;
            }
        }
    },
    computed: mapState({
        repair_list: state => state.other.repair_list
    }),
    methods: {
        ...mapMutations([
            "handleDialog"
        ]),
        ...mapActions([
            "getRepairDetail"
        ]),
        handleGetDetail(id){
            this.getRepairDetail(id);
            this.handleDialog(true)
        }
    },
}
</script>

<style scoped>

</style>